/* SicilyAddict DE - pulsante delle card Bundle (snippets/sa-de-bundle-card.liquid),
   in home (sections/sa-de-home-bundles.liquid) e sulle schede prodotto (sections/sa-de-pdp-bundles.liquid).
   Caricato dalle due sezioni; la guardia window.saBundlesInit evita doppi click-handler se lo script
   compare due volte nella stessa pagina.
   - Un solo POST /cart/add.js con TUTTI i prodotti del bundle: {items:[{id,quantity},...]}
     (data-items sul pulsante = prima variante disponibile di ogni prodotto x quantita' del blocco).
   - Poi evento 'product:added' su <html> con la quantita' totale: e' l'aggancio documentato del tema
     Warehouse (vedi assets/custom.js) con cui il tema ricarica e apre il carrello a scomparsa, lo stesso
     evento che usa l'upsell dello Smart Cart. Prima pero' il carrello a scomparsa si apre e si aggiorna
     subito con l'HTML della sezione mini-cart restituito da /cart/add.js (vedi saCartAfterAdd).
     Con il carrello a pagina (Impostazioni tema > cart_type = page) si va su /cart.
   - L'etichetta resta nello span .sa-i18n (Warenkorb / Carrello, assets/sa-de-i18n.js): caricamento e
     "aggiunto" sono solo classi + icone, cosi' il testo tradotto da GTranslate non si perde. */
(function () {
  'use strict';
  if (window.saBundlesInit) return;
  window.saBundlesInit = true;
 
  function readItems(btn) {
    var raw = btn.getAttribute('data-items');
    if (raw) {
      try {
        return JSON.parse(raw).filter(function (x) { return x && Number(x.id) > 0 && Number(x.quantity) > 0; })
          .map(function (x) { return { id: Number(x.id), quantity: Number(x.quantity) }; });
      } catch (e) { return []; }
    }
    return [];
  }
 
  function setStatus(btn, text, isError) {
    var card = btn.closest('.sa-gm-bundle');
    var el = card && card.querySelector('.sa-gm-bundle__status');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-error', !!isError);
  }
 
  /* Carrello a scomparsa dopo un'aggiunta AJAX (kit e bundle): aperto e aggiornato SUBITO.
     - La richiesta /cart/add.js chiede anche la sezione "mini-cart" (Section Rendering API: sections +
       sections_url): la risposta contiene gia' l'HTML nuovo del carrello. Si sostituisce il CONTENUTO di
       form#mini-cart (non l'elemento: restano aria-hidden e classi, quindi resta aperto), si aggiorna il
       numero nell'header (.header__cart-count) e si apre il carrello se e' chiuso (click sul pulsante
       carrello dell'header, mai se e' gia' aperto).
     - Poi 'cart:rerendered' su <html> (bubbles): Smart Cart guard, barra/upsell e card AOV si aggiornano.
     - Infine 'product:added' per compatibilita' con il tema; se il ridisegno del tema richiude il
       carrello entro 3 s senza un'azione del cliente, viene riaperto.
     - Riserve: senza sezione nella risposta si chiede una volta /?sections=mini-cart; se anche questa
       fallisce resta il ridisegno del tema, con il contenuto attenuato al massimo 1,2 s. */
  var saCartLoadTimer = null;
  function saCartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function saCartIsOpen() {
    var mc = document.getElementById('mini-cart');
    return !!mc && mc.getAttribute('aria-hidden') === 'false';
  }
  function saCartToggleOpen() {
    if (saCartIsOpen()) return true;
    var toggle = document.querySelector('[aria-controls="mini-cart"][data-action="toggle-mini-cart"], [aria-controls="mini-cart"]');
    if (toggle) toggle.click();
    return saCartIsOpen();
  }
  function saCartLoading(on, maxMs) {
    var mc = document.getElementById('mini-cart');
    clearTimeout(saCartLoadTimer);
    if (on && !document.getElementById('sa-cart-loading-css')) {
      var st = document.createElement('style');
      st.id = 'sa-cart-loading-css';
      st.textContent = '#mini-cart.sa-cart-loading{cursor:progress}#mini-cart.sa-cart-loading>*{opacity:.55;transition:opacity .2s}';
      document.head.appendChild(st);
    }
    if (mc) {
      mc.classList.toggle('sa-cart-loading', !!on);
      if (on) mc.setAttribute('aria-busy', 'true'); else mc.removeAttribute('aria-busy');
    }
    if (on) saCartLoadTimer = setTimeout(function () { saCartLoading(false); }, maxMs || 1200);
  }
  /* Parametri da aggiungere al corpo JSON di /cart/add.js */
  function saCartSectionsBody(body) {
    if (document.getElementById('mini-cart')) {
      body.sections = 'mini-cart';
      body.sections_url = window.location.pathname;
    }
    return body;
  }
  /* Sostituisce il contenuto di form#mini-cart con l'HTML della sezione; true se riuscito */
  function saCartApply(html) {
    var live = document.getElementById('mini-cart');
    if (!html || !live || !window.DOMParser) return false;
    var fresh;
    try { fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('mini-cart'); } catch (e) { return false; }
    if (!fresh) return false;
    live.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-item-count');
    if (count !== null) {
      live.setAttribute('data-item-count', count);
      Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count'), function (el) { el.textContent = count; });
    }
    return true;
  }
  /* Per 3 s riapre il carrello se un ridisegno del tema lo chiude senza un'azione del cliente */
  function saCartKeepOpen() {
    var mc = document.getElementById('mini-cart');
    if (!mc || !window.MutationObserver) return;
    var user = false, obs;
    function onUser(e) { if (e.isTrusted) user = true; }
    function stop() {
      if (obs) obs.disconnect();
      document.removeEventListener('click', onUser, true);
      document.removeEventListener('keydown', onUser, true);
    }
    document.addEventListener('click', onUser, true);
    document.addEventListener('keydown', onUser, true);
    obs = new MutationObserver(function () {
      var el = document.getElementById('mini-cart');
      if (user) { stop(); return; }
      if (el && el.getAttribute('aria-hidden') === 'true') { stop(); saCartToggleOpen(); }
    });
    obs.observe(mc, { attributes: true, attributeFilter: ['aria-hidden'] });
    setTimeout(stop, 3000);
  }
  function saCartFire(name, detail) {
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  /* Dopo /cart/add.js riuscito: data = risposta JSON, qty = pezzi aggiunti */
  function saCartAfterAdd(data, qty) {
    if (window.theme && window.theme.cartType === 'page') { window.location.href = saCartRoot() + 'cart'; return; }
    function finish(ok) {
      saCartToggleOpen();
      if (ok) {
        saCartLoading(false);
        saCartFire('cart:rerendered');
      } else {
        saCartLoading(true, 1200);
      }
      saCartKeepOpen();
      saCartFire('product:added', { quantity: qty });
    }
    var html = data && data.sections && data.sections['mini-cart'];
    if (html && saCartApply(html)) { finish(true); return; }
    /* Riserva: carrello aperto subito, contenuto chiesto a parte */
    saCartToggleOpen();
    saCartLoading(true, 4000);
    var url = saCartRoot() + '?sections=mini-cart';
    (window.saAovFetch || window.fetch).call(window, url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { finish(saCartApply(json && json['mini-cart'])); })
      .catch(function () { finish(false); });
  }
 
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-sa-bundle-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;
 
    var items = readItems(btn);
    if (!items.length) return;
    var qty = items.reduce(function (n, x) { return n + x.quantity; }, 0);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 
    btn.disabled = true;
    btn.classList.remove('is-added');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setStatus(btn, '');
 
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(saCartSectionsBody({ items: items }))
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        btn.disabled = false;
        setStatus(btn, btn.getAttribute('data-msg-added'));
 
        saCartAfterAdd(data, qty);
        setTimeout(function () {
          btn.classList.remove('is-added');
          setStatus(btn, '');
        }, 3000);
      })
      .catch(function (error) {
        console.error(error);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        var message = (error && error.description) || btn.getAttribute('data-msg-error') || '';
        setStatus(btn, message, true);
      });
  });
})();
 